import React from 'react';
import './descriptionDisplay.css';

export default class ConfiguratorOptionsDescriptionDisplay extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		}
	}
	
	render() {
		if(!this.props.html) return null;
		if(this.props.long)
			return <div className="description-display">
				<div
					style={{maxHeight: this.state.open ? 5000 : 0, transition: 'max-height 300ms', overflow: 'hidden'}}
					dangerouslySetInnerHTML={{__html:this.props.html}}
				></div>
				<span className={`more ${this.state.open ? 'active' : ''}`} onClick={() => this.setState({open: !this.state.open})}>
					<span>{this.state.open ? 'Collapse' : 'Learn More'}</span>
				</span>
			</div>
		else
			return <div dangerouslySetInnerHTML={{__html:this.props.html}}></div>
	}
}